import { CoreStepper, VerityColorLogo } from "../../core";
import { getBeforeQuizTitle, StepKey } from "../before-quiz";
import i18nPackage from "../../i18n/i18n";
import styles from "./index.module.css";
import { Typography } from "@mui/material";
import { CoreVerticalStepperWrapper, StepConfig } from "../../core/stepper/Stepper";
import { useMemo } from "react";

export type BeforeQuizStepperProps = {
	steps: StepKey[];
	onStepChange: (step: number) => void;
	completedSteps: number[];
	activeStep: number;
	isCompatibilityCheck: boolean;
	/**If disabled, user cannot jump steps */
	disabled?: boolean;

	/**Verify Identity step has dynamic step label. Not sure what to do because I want to have text in one place */
	onlySignature: boolean;

	/** Exposes these steps to assistive tech as an ARIA tabs widget, since they drive the single visible step panel */
	tabsConfig?: { idPrefix: string; panelId: string };
};

export function BeforeQuizStepper({
	steps,
	onStepChange,
	completedSteps,
	activeStep,
	onlySignature,
	isCompatibilityCheck,
	disabled,
	tabsConfig,
}: BeforeQuizStepperProps) {
	const stepperConfig = useMemo((): StepConfig<string>[] => {
		return steps.map((step) => {
			const stepKey = step === "verifyIdentity" && onlySignature ? "signatureOnly" : step;

			return {
				key: stepKey,
				label: i18nPackage.t(`beforeQuiz.stepper.${stepKey}`),
			};
		});
	}, [steps, onlySignature]);

	// Title should span 2 lines because space is small if not compatiblity check
	const title = isCompatibilityCheck
		? getBeforeQuizTitle(isCompatibilityCheck)
		: i18nPackage.t("beforeQuiz.title2Lines");

	return (
		<CoreVerticalStepperWrapper
			label={
				<div className={styles.stepperTitleWrapper}>
					<VerityColorLogo width={32} height={32} />
					<Typography variant="h1">{title}</Typography>
				</div>
			}
			className={styles.beforeQuizStepperContainer}
		>
			<CoreStepper
				steps={stepperConfig}
				onStepChange={disabled ? undefined : onStepChange}
				completedSteps={completedSteps}
				vertical
				activeStep={activeStep}
				tabsConfig={tabsConfig}
				sx={{
					padding: 0,
					border: "none",
					borderRadius: 0,
				}}
			/>
		</CoreVerticalStepperWrapper>
	);
}
